import { AlertDestinationsApiFactory, V1AlertDestination } from '@vacancorp/enterprise-for-client.vacanservice.com'
import { AlertDestination } from '@/models'
import { api, ApiResponse, ListResponse, createApiError } from './base'

function createAlertDestinations(rawAlertDestinations?: V1AlertDestination[]): AlertDestination[]{
  if (!rawAlertDestinations) return []

  return rawAlertDestinations?.map(ad => new AlertDestination({
    id: ad.id,
    companyId: ad.companyId,
    name: ad.name,
    mailAddress: ad.mailAddress,
    longStayAlertEnabled: ad.longStayAlertEnabled,
    failureAlertEnabled: ad.failureAlertEnabled,
    lowBatteryAlertEnabled: ad.lowBatteryAlertEnabled,
  }))
}

export const NewAlertDestinationsApiFunc = () => {
  const webAdapter = AlertDestinationsApiFactory(undefined, api.defaults.baseURL, api)

  return {
    listAlertDestinations: async (companyId: string, filter?: string, page?: number): Promise<ApiResponse<ListResponse<AlertDestination>>> => {
      let data, currentPage, totalPage, err

      try {
        const res = await webAdapter.listAlertDestinations(companyId, filter, page)
        data = createAlertDestinations(res.data.alertDestinations)
        currentPage = res.data.currentPage
        totalPage = res.data.totalPage
      } catch (e) {
        data = [] as AlertDestination[]
        err = createApiError(e)
      }

      return {
        data: {
          list: data,
          currentPage: currentPage || 1,
          totalPage: totalPage || 1,
        },
        err
      }
    },

    getAlertDestination: async (companyId: string, alertDestinationId: string): Promise<ApiResponse<AlertDestination | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.getAlertDestination(companyId, alertDestinationId)
        data = createAlertDestinations([res.data])[0]
      } catch (e) {
        data = undefined
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    },

    createAlertDestination: async (companyId: string, alertDestination: AlertDestination): Promise<ApiResponse<AlertDestination | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.createAlertDestination(companyId, { data: alertDestination })
        data = createAlertDestinations([res.data])[0]
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    },

    updateAlertDestination: async (companyId: string, alertDestinationId: string, alertDestination: AlertDestination): Promise<ApiResponse<AlertDestination | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.updateAlertDestination(companyId, alertDestinationId, { data: alertDestination })
        data = createAlertDestinations([res.data])[0]
      } catch (e) {
        data = undefined
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    },

    deleteAlertDestination: async (companyId: string, alertDestinationId: string): Promise<ApiResponse<AlertDestination | undefined>> => {
      let data, err

      try {
        await webAdapter.deleteAlertDestination(companyId, alertDestinationId)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err
      }
    }
  }
}